import {useMemo} from "react";
import {Col, Row} from "antd";
import {Link} from "react-router-dom";

import imgPeople from "../../../assets/image/addProducts/people1.jpg";
import {HeaderImage} from "../../../components/layout/shared/header_image/HeaderImage";
import {AppSearchInput} from "../../../shared/ui/search-input";
import {AppSelect} from "../../../shared/ui/select";
import {Page} from "../../../shared/ui/page";
import {SmartTable} from "../../../shared/ui/smart-table";
import {ApproveDenyButton} from "../../../shared/ui/approve-deny-button";
import { ApprovalActionModal } from "../../../shared/ui/approval-action-modal";
import {getCatalogSupervisionColumns} from "../model/getCatalogSupervisionColumns";
import {useCatalogSupervisionValidationPage} from "../model/useCatalogSupervisionValidationPage";
import {
    BottomActions,
    ContentSection,
    HeaderSection,
    StyledDivider,
    TableCard,
    TableContainer,
    ToolbarCard,
    ToolbarDivider,
} from "./CatalogSupervisionValidationPage.styles";

export const CatalogSupervisionValidationPage = () => {
    const {
        loadingInitial,
        loadingPlans,
        loadingSuppliers,
        loadingTable,
        approving,
        convocationOptions,
        planOptions,
        supplierOptions,
        selectedConvocation,
        selectedPlan,
        selectedSupplier,
        rows,
        rowCount,
        page,
        pageSize,
        searchQuery,
        showApprovalModal,
        approvalAction,
        approvalComment,
        handleSelectedConvocation,
        handleSelectedPlan,
        handleSelectedSupplier,
        handleSearchChange,
        handlePageChange,
        handleRowSelectionChange,
        openApprovalModal,
        closeApprovalModal,
        setApprovalAction,
        setApprovalComment,
        handleApproveSubmit,
        reloadProducts,
    } = useCatalogSupervisionValidationPage();

    const columns = useMemo(() => getCatalogSupervisionColumns(), []);

    const pageHeader = useMemo(
        () => ({
            title: "Validación de Supervision",
            breadcrumbs: [
                {title: <Link to="/admin">Inicio</Link>},
                {title: <Link to="/admin/products-supervision">Validación de Supervision</Link>},
            ],
        }),
        []
    );

    return (
        <Page
            showPageHeader
            header={pageHeader}
            contentPadding="0"
            minHeight="auto"
        >
            <HeaderSection>
                <HeaderImage imageHeader={imgPeople} titleHeader="Listado de productos"/>
            </HeaderSection>

            <ContentSection>
                <Row gutter={[0, 16]}>
                    <Col span={24}>
                        <StyledDivider/>
                    </Col>

                    <Col span={24}>
                        <ToolbarCard bordered>
                            <Row gutter={[12, 12]}>
                                <Col xs={24} sm={12} md={8} lg={6} xl={6} xxl={6}>
                                    <AppSelect
                                        value={selectedConvocation}
                                        options={convocationOptions}
                                        placeholder="Selecciona una Jornada"
                                        onChange={handleSelectedConvocation}
                                        isLoading={loadingInitial}
                                    />
                                </Col>

                                <Col xs={24} sm={12} md={8} lg={6} xl={6} xxl={6}>
                                    <AppSelect
                                        value={selectedPlan}
                                        options={planOptions}
                                        placeholder="Selecciona un Plan"
                                        onChange={handleSelectedPlan}
                                        isLoading={loadingPlans}
                                        isDisabled={!selectedConvocation || loadingInitial}
                                        noOptionsMessage={() =>
                                            selectedConvocation ? "Sin planes" : "Selecciona una jornada"
                                        }
                                    />
                                </Col>

                                <Col xs={24} sm={12} md={8} lg={6} xl={6} xxl={6}>
                                    <AppSelect
                                        value={selectedSupplier}
                                        options={supplierOptions}
                                        placeholder="Selecciona un Proveedor"
                                        onChange={handleSelectedSupplier}
                                        isLoading={loadingSuppliers}
                                        isDisabled={!selectedPlan || loadingPlans}
                                        noOptionsMessage={() =>
                                            selectedConvocation ? "Sin proveedores" : "Selecciona una jornada"
                                        }
                                    />
                                </Col>

                                <Col xs={24} sm={12} md={8} lg={6} xl={6} xxl={6}>
                                    <AppSearchInput
                                        placeholder="Buscar..."
                                        value={searchQuery}
                                        onChange={handleSearchChange}
                                    />
                                </Col>
                            </Row>

                            <ToolbarDivider/>
                        </ToolbarCard>
                    </Col>

                    <Col span={24}>
                        <TableCard bordered>
                            <TableContainer>
                                <SmartTable
                                    rowKey="rowKey"
                                    columns={columns}
                                    dataSource={rows}
                                    loading={loadingTable}
                                    total={rowCount}
                                    currentPage={page + 1}
                                    onPageChange={handlePageChange}
                                    showPagination
                                    pageSizeOptions={["10", "50", "100"]}
                                    defaultPageSize={String(pageSize)}
                                    enableRowSelection
                                    onRowSelectionChange={handleRowSelectionChange}
                                    showToolbar
                                    reload={reloadProducts}
                                    showColumnSettings={false}
                                    showTableResize={false}
                                    dangerRowCondition={(record) => record?.isOutOfRange}
                                    scroll={{x: "max-content"}}
                                />
                            </TableContainer>

                            <BottomActions>
                                <ApproveDenyButton
                                    onClick={openApprovalModal}
                                    loading={approving}
                                    disabled={loadingInitial || loadingPlans || loadingSuppliers}
                                >
                                    Aprobar / Denegar
                                </ApproveDenyButton>
                            </BottomActions>
                        </TableCard>
                    </Col>
                </Row>
            </ContentSection>

            <ApprovalActionModal
                isOpen={showApprovalModal}
                action={approvalAction}
                comment={approvalComment}
                submitting={approving}
                onActionChange={setApprovalAction}
                onCommentChange={setApprovalComment}
                onCancel={closeApprovalModal}
                onConfirm={handleApproveSubmit}
            />
        </Page>
    );
};
